import React from 'react'

import MuiPagination, {
  PaginationProps as MuiPaginationProps
} from '@mui/material/Pagination'

type PaginationProps = Omit<MuiPaginationProps, 'onChange'> & {
  onChange: (page: number) => void
}

const Pagination = ({ count, page, onChange, ...rest }: PaginationProps) => {
  return (
    <MuiPagination
      count={count}
      page={page}
      onChange={(e, page) => onChange(page)}
      color="primary"
      variant="outlined"
      {...rest}
    />
  )
}

export default Pagination
